import { SITELINKS } from "../../../app-routes/links";
import AuthLayout from "./AuthLayout";
import { AuthHeading, BackLink, FormAlert } from "./FormControls";

/**
 * Self-service password reset is switched off for admins: the 2FA code goes to the
 * same inbox as a reset code, so email alone would be enough to take over an account.
 * A locked-out admin is reset by another admin (backend maintenance action
 * "reset-admin-password"). The previous self-service form is in git history and the
 * backend endpoints still exist behind ADMIN_SELF_SERVICE_RESET, for use together with
 * app-based 2FA later.
 */
const AdminResetNotice = ({ title }: { title: string }) => (
  <AuthLayout title={`${title} | HoneConnect Admin`}>
    <BackLink to={SITELINKS.SIGNIN} label="Back to sign in" />
    <AuthHeading
      title={title}
      description="For security, admin passwords are reset by your admin team rather than by email."
    />
    <FormAlert
      tone="info"
      message="Contact another admin. They will set a temporary password for you, and you'll sign in with it and your 2FA code as usual."
    />
  </AuthLayout>
);

export default AdminResetNotice;
